<template>
  <div class="home">
    <div class="head-title">公海用户</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <!-- <el-button @click="onSubmit = true" type="primary" icon="el-icon-plus"
            >添加</el-button
          > -->
          <el-table
            :data="tableData.data"
            border
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            style="width: 100%; text-aligh: center; margin-top: 2.0rem"
          >
            <el-table-column prop="account" label="账号"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column prop="province" label="省"></el-table-column>
            <el-table-column prop="city" label="城市"></el-table-column>
            <el-table-column prop="address" label="详细地址"></el-table-column>
            <el-table-column
              prop="enterpriseName"
              label="企业名称"
            ></el-table-column>
            <el-table-column
              prop="enterpriseScale"
              label="企业规模"
            ></el-table-column>
            <el-table-column prop="enterprisePhoto" label="营业执照">
              <template slot-scope="scope">
                <img
                  :src="`${scope.row.enterprisePhoto}`"
                  min-width="70"
                  height="70"
                />
              </template>
            </el-table-column>
            <el-table-column prop="addtime" label="时间"></el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="abc"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tableData: {
        data: [],
        total: 0,
      },
      url: "https://api.weijub.com",
      tooken: "",
      title: {},
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.abc();
  },
  methods: {
    handleCurrentChange(val) {
      this.axios
        .post(
          "/api/index/seasAccount",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            page: val,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    abc() {
      this.axios
        .post(
          "/api/index/seasAccount",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },

    // 提交过后输出的数据\
    transignificance(val, type) {
      for (const key in type) {
        if (key * 1 === val) {
          return type[key];
        }
      }
    },
  },
  // 1.用户分配
  // 2.用户分配
};
</script>
<style scoped>
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
</style>


